/* eslint-disable max-lines */
/** RESTFUL-REQUEST */
// export const RESTFUL_SERVER_URL = 'http://gateway-dev.easefuture.com/massage-server'; // @sl
export const RESTFUL_SERVER_URL = 'http://gateway-qa.easefuture.com/massage-server'; // @qa
// export const RESTFUL_SERVER_URL = 'http://gateway-pre.easefuture.com/massage-server'; // @uat
// export const RESTFUL_SERVER_URL = 'https://gateway.easefuture.com/massage-server-gray'; // @gray
// export const RESTFUL_SERVER_URL = 'http://gateway.easefuture.com/massage-server'; // @prod

export const storagePrefix = 'https://static.easefuture.com/massage-robot-front/avatarkit/massage-robot-pad';

export const ossPrefix = 'https://static.easefuture.com/massage-robot-front';

export const robotStoragePrefix = 'https://static.easefuture.com/massage-robot-front/avatarkit/massage-robot';

export const ICON_CDN_LINK =
  'https://static.easefuture.com/massage-robot-front/resource/massage-robot-pad-v2/8u-rKyEtNLjCYp8.json';
export const storagePrefixFixedV2 = 'https://static.easefuture.com/massage-robot-front/avatarkit/massage-robot-pad-v2';
export const storagePrefixV2 = 'https://static.easefuture.com/massage-robot-front/avatarkit/massage-robot-pad-v2/image';
// 图片上传服务
const IMAGE_SERVER: Record<Exclude<ENVType, 'pre' | 'undefined'>, string> = {
  dev: 'https://massage-http-server-12445-5000.apps-sl.danlu.netease.com',
  qa: 'https://massage-http-server-7513-5000.apps-qa.danlu.netease.com',
  prod: 'https://massage-http-server-7554-5000.apps-hp.danlu.netease.com',
};

export const IMAGE_SERVER_URL = IMAGE_SERVER['dev'];

export const SIGNATURE_SECRET = '19764ad35d654e9c92f43bc82722df31';

// eslint-disable-next-line fuxi/uppercase-const
export const PartLists: Array<{
  name: string;
  partName: Service.BodyPart;
}> = [
  {
    name: '肩部',
    partName: 'Shoulder',
  },
  {
    name: '腰部',
    partName: 'Waist',
  },
  {
    name: '腰背',
    partName: 'Back',
  },
  {
    name: '腹部',
    partName: 'Abdomen',
  },
  {
    name: '腿部',
    partName: 'LowerBody',
  },
];

export enum DAYJS_FORMAT {
  YEAR = 'YYYY',
  MONTH = 'YYYY-MM',
  DATE = 'YYYY-MM-DD',
  MINUTES = 'YYYY-MM-DD HH:mm',
  SECONDS = 'YYYY-MM-DD HH:mm:ss',
  MINUTESCHINESE = 'YYYY年MM月DD日 HH:mm',
}

export enum ABNORMAL_ORDER_STATE {
  reported = '已上报',
  accepted = '已受理',
  processing = '问题排查中',
  feedback = '客服已反馈',
  communication = '沟通中',
  completed = '已解决',
}

export enum ALL_PAGES {
  /** 首页 */
  HOME = '/home',
  /** 会员详情页 */
  MEMBER_DETAIL = '/user/member-detail',
  /** 搜索会员 */
  SEARCH_MEMBER = '/user/search-member',
  /** 编辑会员 */
  EDIT_MEMBER = '/user/edit-member',
  /** 添加会员 */
  ADD_MEMBER = '/user/add-member',
  /** 会员3D身体变化 */
  BODY_CHANGE_3D = '/user/body-change-3d',
  /** 设备管理页 */
  DEVICE_MANAGEMENT = '/device/management',
  /** 定位辅助页 */
  POS_ASSIST = '/device/pos-assist',
  /** 非矩阵式艾灸设置页 */
  MASSAGE_SETTING = '/service/massage-setting',
  /** 矩阵式艾灸设置页 */
  MASSAGE_SETTING_MOX = '/service/massage-setting-mox',
  /** 动作测试 */
  ACTION_TEST = '/service/action-test',
  /** 动作复测 */
  ACTION_RETEST = '/service/action-retest',
  /** 机器配网 */
  NETWORK_CONFIG = '/device/network-config',
  /** 创建订单 */
  ADD_SERVICE = '/service/add-service',
  /** 帮助与反馈 */
  HELP_FEEDBACK = '/help/home',
  // 问题反馈
  ISSUE_FEEDBACK = '/help/issue-report',
  // 问题反馈进度
  FEEDBACK_PROGRESS = '/help/feedback-progress',
  // 使用技巧
  USE_SKILLS = '/help/use-skills',
  // 版本更新公告
  VERSION_UPDATE_NOTICE = '/help/version-update-notice',
  // 相关文档iframe入页面
  IFRAME_CONTENT = '/help/iframe-content',
  /** 沉浸模式 */
  IMMERSION_MODE = '/service/immersion-mode',
  /** 按摩控制 */
  MASSAGE_CONTROL = '/service/massage-control',
  /** 会员记录详情 */
  MEMBER_RECORD_DETAIL = '/service-record-detail',
  /** 软硬件检测工具 */
  ISSUE_DETECT_TOOL = '/device/issue-detect-tool',
  /** AI问诊 */
  AI_CONSULTATION = '/ai-consultation',
  /** 射频围度测量页面 */
  BODY_MEASUREMENT = '/service/body-measurement',
  /** 射频围度测量页面 */
  BODY_REMEASUREMENT = '/service/body-remeasurement',
}

/** 隐藏tabbar的页面 */
export const TAB_BAR_HIDE_ROUTE = [
  '/login',
  ALL_PAGES.POS_ASSIST,
  // 设备绑定页面不隐藏logo
  // '/device-binding',
  ALL_PAGES.SEARCH_MEMBER,
  ALL_PAGES.NETWORK_CONFIG,
  ALL_PAGES.FEEDBACK_PROGRESS,
  ALL_PAGES.USE_SKILLS,
  ALL_PAGES.IMMERSION_MODE,
  ALL_PAGES.ISSUE_DETECT_TOOL,
  ALL_PAGES.AI_CONSULTATION,
  ALL_PAGES.IFRAME_CONTENT,
  ALL_PAGES.VERSION_UPDATE_NOTICE,
  ALL_PAGES.ISSUE_FEEDBACK,
];

export const MassageType2Text: Record<Massage.MassageItem, string> = {
  Shockwave: '磁震波',
  RadioFrequency: '内源热能',
  Moxibustion: '艾灸',
  Massage: '按摩',
  HotStone: '筋膜再生宝',
};

// 接口状态码
export enum STATUS_CODE {
  OK = 0,
  BAD_REQUEST = 1,
  SYSTEM_ERROR = 2,
  INVALID_TOKEN = 3,
  LOGIN_REQUIRED = 4,
  USER_NOT_EXISTS = 100,
  DEVICE_NOT_ONLINE = 200,
  DEVICE_BUSY = 201,
  NO_RUNNING_TASK = 300,
  TASK_NOT_EXISTS = 301,
  TASK_IS_FINISHED = 302,
  MASSAGE_NOT_FOUND = 303,
  MASSAGE_PACKAGE_NOT_FOUND = 304,
  /** 设备调用失败 */
  DEVICE_INVOKE_ERROR = 40019,
}

// 按摩状态
export enum MassageState {
  IDLE = 'IDLE',
  PREPARING = 'PREPARING',
  RUNNING = 'RUNNING',
  PAUSING = 'PAUSING',
  PAUSED = 'PAUSED',
  FINISHING = 'FINISHING',
  FINISHED = 'FINISHED',
  DISCONNECT = 'DISCONNECT',
}

export enum OrderState {
  Created = '已创建',
  Serving = '服务中',
  Abnormal = '异常',
  Completed = '服务完成',
  Terminated = '人工终止',
}

export enum MachineState {
  Offline = '离线',
  Busy = '服务中',
  Idle = '空闲',
  Abnormal = '异常',
  ManualOnly = '仅支持人工',
  BeyondRange = '超出门店工作范围',
  Upgrading = '升级中',
  UpgradeSuccess = '升级成功',
  UpgradeFail = '升级失败',
  ShuttingDown = '关机中',
}

export enum DeviceStatePhoto {
  online = storagePrefixV2 + '/device-online.png',
  offline = storagePrefixV2 + '/device-offline.png',
}
// 版本升级说明文档
export const VERSION_INSTRUC_LINK = 'https://docs.popo.netease.com/lingxi/71ca3fde6c3e49f4884000ea575eace4';
// 常见问题文档
export const COMMON_PROBLEMS_LINK = 'https://docs.popo.netease.com/lingxi/7dc6c7dfb7ac4b688bea6553fd7d644e';

// 使用说明书文档
export const USER_GUIDE_LINK = 'https://docs.popo.netease.com/lingxi/fcb1ecac21fc425c88f839946325dec3';

// 视频通用兜底图
export const COMMON_VIDEO_POSTER = storagePrefixV2 + '/video-poster.png';

export const TOKEN_IDENTIFY = 'MSG_TOKEN';
export const CURRENT_ANDROID_ID = 'CURRENT_ANDROID_ID';
export const DEVICE_NOT_BIND = 'DEVICE_NOT_BIND';
export const SELECTED_STORE = 'selected-store';
export const SELECTED_CUSTOMER_ID = 'selected-customer-id';
export const SELECTED_MACHINE_CAMERA_TYPE = 'selected-machine-camera-type';
export const CURRENT_ORDER_ID = 'current-order-id';
export const VERIFY_CODE_INTERVAL = 90000;
export const LAST_SEE_UPDATE_LOG = 'last-see-update-log';
export const CURRENT_ORDER_IS_DRAFT = 'current-order-is-draft';
export const MASSAGE_SETTING_CACHE = 'massage-setting-cache';
export const APP_LOCATION_IS_UNAVAILABLE = 'app-location-is-unavailable';
export const HAS_SHOWED_TIPS_MODAL = 'has-showed-tips-modal';
export const STORAGE_LOCATION_COORDS = 'storage-location-coords';
export const JUDGE_AS_VERTICAL_SCREEN_HEIGHT = 900;
export const IS_OPEN_IMMER_MODE = 'is-open-immer-mode';

export enum MemberSource {
  OTHERS = '其他',
}

export enum BODY_PART {
  Shoulder = '肩部',
  Abdomen = '腹部',
  Waist = '腰部',
  Back = '腰背',
  All = '',
}

export enum COORDINATE_TYPE {
  BAIDU = 'BD09',
  GAODE = 'GCJ02',
  WGS84 = 'WGS84',
}

export enum UPPER_STATUS_CODE {
  /** 请求错误 */
  BadRequest = 10000,
  /** 禁止操作 */
  Forbidden = 10001,
  /** 服务异常 */
  ServerError = 10002,
  /** 登录凭证错误 */
  InvalidToken = 10003,
  /** 请先登录 */
  LoginRequired = 10004,
  /** 没有权限 */
  PermissionDenied = 10005,
  /** 账号已被禁用 */
  AccountDisabled = 10006,
  /** 账号未找到 */
  AccountNotFound = 10007,
  /** 验证码错误 */
  SmsCodeError = 10008,
  /** 请输入验证码 */
  SmsCodeMissing = 10009,
  /** 验证码发送过于频繁，请稍后再试 */
  SmsCodeCooling = 10010,
  /** 会员已存在 */
  CustomerAlreadyExist = 20000,
  /** 会员不存在 */
  CustomerNotExist = 20001,
  /** 手机号已存在 */
  PhoneNumAlreadyExist = 20003,
  /** 请输入正确的手机号 */
  PhoneNumIllegal = 20004,
  /** 订单不存在 */
  OrderNotExist = 30000,
  /** 请先完成服务中的订单 */
  ServiceOrderConflict = 30001,
  /** 当前订单不支持人工结束 */
  ServiceOrderTerminatingFail = 30002,
  /** 方案不存在 */
  SchemeNotFound = 30100,
  /** 按摩任务不存在 */
  MassageTaskNotFound = 30101,
  /** 请先进行按摩设置 */
  NoMassageSettings = 30102,
  /** 手诊单不存在 */
  PalpationSheetNotExist = 30200,
  /** 动作测试问卷未找到 */
  QuestionnaireNotFound = 30300,
  /** 动作测试问卷不一致 */
  QuestionnaireNotMatch = 30301,
  /** 动作测试结果已经存在 */
  ActionTestResultAlreadyExists = 30302,
  /** 动作测试服务步骤错误 */
  ActionTestStepError = 30303,
  /** 未上传耗材码异常错误码 */
  ConsumablesQRNotUploadError = 30401,
  /** 设备离线 */
  DeviceOffline = 40000,
  /** 设备繁忙 */
  DeviceBusy = 40001,
  /** 设备占用失败 */
  DeviceOccupyFail = 40002,
  /** 未找到该设备 */
  DeviceNotFound = 40003,
  /** 未连接设备 */
  DeviceNotConnected = 40005,
  /** 绑定密码错误 */
  NOT_VALID_PASSWORD = 40101,
  /** 还未绑定设备 */
  DeviceNotYetBound = 40102,
  /** 机器在停驻或者解锁中 */
  ChassisLockingOrUnLocking = 40025,
  /** 设备软件版本过低 */
  DEVICE_SOFTWARE_VERSION_TOO_LOW = 40024,
  /** 操作设备软件过低 */
  OP_DEVICE_SOFTWARE_TOO_LOW = 40105,
  /** 机器人版本不支持某方案*/
  DEVICE_SOFTWARE_BY_PRODUCT_MIN_VERSION = 40026,
  DEVICE_SOFTWARE_BY_PRODUCT_MAX_VERSION = 40027,
  // 订单超时结束
  ORDER_END_OF_TIMEOUT = 302,
  /** 设备已被锁机 */
  DEVICE_HAS_BEEN_LOCKED = 40200,
  /** 耗材码核销错误 */
  CONSUMABLE_CODE_INVALID = 30402,
  /** 服务卡核销错误 */
  VERIFY_CODE_INVALID = 30406,
  /** 选择的方案已更新 */
  SELECTED_PLAN_UPDATE = 30106,
  /** 门店配置的授权额度不足 */
  INSUFFICIENT_AUTHORIZATION_QUOTA = 30601,
}

export enum TOAST_CONTAINER_ID {
  BasicLayout = 'basic-layout',
  ImmersionMode = 'immersion-mode',
}

export enum TypeImage {
  Shockwave = '/device-running-bg/device-running-bg-Shockwave.png',
  RadioFrequency = '/device-running-bg/device-running-bg-RadioFrequency.png',
  Moxibustion = '/device-running-bg/device-running-bg-Moxibustion.png',
  Massage = '/device-running-bg/device-running-bg-massage-new.png',
  MatrixMoxibustion = '/device-running-bg/device-running-bg-MatrixMoxibustion.png',
  HotStone = '/hotstone-bg.png',
}

export enum ShockwaveType {
  DEJI = 1,
  ALAN = 2,
}

export enum GenderLabel {
  Male = '男',
  Female = '女',
}

/** 忽略更新的pad id */
export const IGNORE_UPDATE_PAD_IDS = ['2baa1dd520abe11e', 'f013947ff3314f5b'];

export const PAIN_LEVEL_LIST = [
  {
    id: 0,
    desc: '察觉不到',
    backgroundColor: 'linear-gradient(180deg, #99FFD4 6.76%, #21DA8C 100%)',
    colorText: '#21DA8C',
  },
  {
    id: 1,
    desc: '刚刚注意到',
    backgroundColor: 'linear-gradient(180deg, #9FFFFF 0%, #18D9D9 100%)',
    colorText: '#18D9D9',
  },
  {
    id: 2,
    desc: '轻度疼痛',
    backgroundColor: 'linear-gradient(180deg, #6FBAFF 0%, #1382E8 100%)',
    colorText: '#1885E9',
  },
  {
    id: 3,
    desc: '中度疼痛',
    backgroundColor: 'linear-gradient(180deg, #FFE897 0%, #EEC329 96.93%)',
    colorText: '#EEC329',
  },
  {
    id: 4,
    desc: '重度疼痛',
    backgroundColor: 'linear-gradient(180deg, #FFBE99 0%, #E56116 98.4%)',
    colorText: '#E56116',
  },
  {
    id: 5,
    desc: '剧烈疼痛',
    backgroundColor: 'linear-gradient(180deg, #FE8B71 0%, #B81F1F 98.46%)',
    colorText: '#B81F1F',
  },
];
